/**
 * NavTooltip — WHY / WHAT / HOW tooltip with 300ms hover delay.
 *
 * Appears to the right of the sidebar nav item on hover.
 * Three colored labels (Why=blue, What=green, How=amber) with
 * descriptive text for each navigation item.
 *
 * (COORD-23: ROS Shell Wrap)
 */

import { useState, useRef } from "react";

export default function NavTooltip({ tooltip, children }) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  const handleMouseEnter = () => {
    if (!tooltip) return;
    timerRef.current = setTimeout(() => setVisible(true), 300);
  };

  const handleMouseLeave = () => {
    clearTimeout(timerRef.current);
    setVisible(false);
  };

  if (!tooltip) return children;

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {visible && (
        <div className="absolute left-full top-0 ml-2 z-[60] w-64 bg-gray-900 text-white rounded-lg shadow-xl p-3 text-xs pointer-events-none">
          {tooltip.why && (
            <div className="mb-1.5">
              <span className="text-blue-400 font-semibold uppercase text-[10px] tracking-wide">
                Why
              </span>
              <p className="text-gray-300 mt-0.5 leading-snug">{tooltip.why}</p>
            </div>
          )}
          {tooltip.what && (
            <div className="mb-1.5">
              <span className="text-emerald-400 font-semibold uppercase text-[10px] tracking-wide">
                What
              </span>
              <p className="text-gray-300 mt-0.5 leading-snug">{tooltip.what}</p>
            </div>
          )}
          {tooltip.how && (
            <div>
              <span className="text-amber-400 font-semibold uppercase text-[10px] tracking-wide">
                How
              </span>
              <p className="text-gray-300 mt-0.5 leading-snug">{tooltip.how}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
